module.exports = __webpack_public_path__ + "img/16-5.87836067.png";